import {ActionReducer, ActionReducerMap, MetaReducer} from "@ngrx/store";
import {
  AuthActions,
  Product,
  PRODUCT_DETAIL_ENTITY,
  PRODUCT_SEARCH_RESULTS_BY_CODES_ENTITY,
  PRODUCT_SEARCH_RESULTS_BY_CATEGORY_ENTITY,
  ProductsState,
  SiteContextActions
} from "@spartacus/core";
import {InjectionToken, Provider} from "@angular/core";

import * as fromProductReferences from './custom-product-references.reducer';
import * as fromProductReviews from './custom-product-reviews.reducer';
import * as fromProductsSearch from './custom-product-search.reducer';
import {entityScopedLoaderReducer} from "../../../state/utils/scoped-loader/entity-scoped-loader.reducer";

export function getReducers(): ActionReducerMap<ProductsState> {
  return {
    search: fromProductsSearch.reducer,
    searchByCode: entityScopedLoaderReducer<Product>(
      PRODUCT_SEARCH_RESULTS_BY_CODES_ENTITY
    ),
    searchByCategory: entityScopedLoaderReducer<Product[]>(
      PRODUCT_SEARCH_RESULTS_BY_CATEGORY_ENTITY
    ),
    details: entityScopedLoaderReducer<Product>(PRODUCT_DETAIL_ENTITY),
    reviews: fromProductReviews.reducer,
    references: fromProductReferences.reducer
  };
}

export const reducerToken: InjectionToken<
  ActionReducerMap<ProductsState>
  > = new InjectionToken<ActionReducerMap<ProductsState>>('ProductReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};

export function clearProductsState(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return function (state, action) {
    if (
      action.type === SiteContextActions.CURRENCY_CHANGE ||
      action.type === SiteContextActions.LANGUAGE_CHANGE ||
      action.type === AuthActions.LOGIN ||
      action.type === AuthActions.LOGOUT
    ) {
      state = undefined;
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearProductsState];
